import React from "react";

// You can further customize colors and transitions in your Tailwind config or CSS.
const Premissions = ({ values, setValues, texts }) => {
    return (
        <div className="flex flex-wrap gap-6 p-6 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-700 rounded-xl shadow-2xl premissions">
            {Object.entries(values).map(([key1, value]) => (
                <div key={key1} className="flex flex-col bg-gray-800 p-6 rounded-2xl shadow-lg min-w-[280px] max-w-xs transition-transform hover:scale-105 hover:shadow-2xl border border-gray-700">
                    <div className="mb-4 flex items-center gap-2">
                        <div className="w-2 h-2 bg-gradient-to-r from-green-400 to-blue-500 rounded-full animate-pulse" />
                        <p className="text-lg font-bold tracking-wide text-white capitalize">{texts?.user[key1.toLowerCase()]}</p>
                    </div>
                    <div className="space-y-4">
                        {Object.entries(value).map(([key, val]) => (
                            <div key={key} className="ml-3">
                                {Array.isArray(val) ? (
                                    <div>
                                        <p className="text-base font-semibold text-gray-300 mb-2">{key}</p>
                                        <div className="space-y-2">
                                            {val.map((obj, i) => (
                                                <div key={i} className="flex items-center justify-between px-2 py-1 bg-gray-700 rounded-lg hover:bg-gray-600 transition">
                                                    <span className="text-gray-200">{obj.name === "" ? "REST" : obj.name}</span>
                                                    <input
                                                        type="checkbox"
                                                        className="form-checkbox h-5 w-5 text-blue-500 focus:ring-2 focus:ring-blue-400 transition"
                                                        checked={obj.allowed}
                                                        onChange={(e) => {
                                                            const newValues = { ...values };
                                                            newValues[key1][key][i].allowed = e.target.checked;
                                                            setValues(newValues);
                                                        }}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="flex items-center justify-between px-2 py-1 bg-gray-700 rounded-lg hover:bg-gray-600 transition">
                                        <span className="text-gray-200">{key}</span>
                                        <input
                                            type="checkbox"
                                            className="form-checkbox h-5 w-5 text-blue-500 focus:ring-2 focus:ring-blue-400 transition"
                                            checked={val}
                                            onChange={(e) => {
                                                const newValues = { ...values };
                                                newValues[key1][key] = e.target.checked;
                                                setValues(newValues);
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Premissions;
